import { render, staticRenderFns } from "./ClosedDayAdd.vue?vue&type=template&id=32707ae0"
import script from "./ClosedDayAdd.vue?vue&type=script&lang=ts"
export * from "./ClosedDayAdd.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports